import { AffiliationType, AffiliationBoardPosition } from 'generated/graphql';

export const getAffiliationType = (type?: AffiliationType): string => {
  switch (type) {
    case 'BoardMember':
      return 'Board Member';

    case 'FamilyMemberAffiliation':
      return 'Family Member Affiliation';

    case 'PersonalConnection':
      return 'Personal Connection';

    default:
      return type ?? '';
  }
};

export const getAffiliationBoardPosition = (type?: AffiliationBoardPosition): string => {
  switch (type) {
    case 'VicePresident':
      return 'Vice President';

    default:
      return type ?? '';
  }
};
